<div class="account-details flex flex-1 flex-col gap-6">
  <app-drawer-section>
    <dl class="m-0 divide-y divide-border-muted text-body-sm">
      <div class="flex items-baseline justify-between gap-4 px-4 py-3">
        <dt class="text-text-muted">Balance</dt>
        <dd
          class="m-0 font-semibold tabular-nums"
          [class.text-status-danger]="negativeBalance"
          [class.text-text-title]="!negativeBalance"
        >
          @if (negativeBalance) {
            <span>(</span>
          }
          {{ account().balance.current | currency: 'USD' : 'symbol' : '1.2-2' }}
          @if (negativeBalance) {
            <span>)</span>
          }
        </dd>
      </div>
      <div class="flex items-baseline justify-between gap-4 px-4 py-3">
        <dt class="text-text-muted">Type</dt>
        <dd class="m-0 font-semibold text-text-title">{{ account().type | titlecase }}</dd>
      </div>
      @if (account().subtype.trim()) {
        <div class="flex items-baseline justify-between gap-4 px-4 py-3">
          <dt class="text-text-muted">Subtype</dt>
          <dd class="m-0 font-semibold text-text-title">{{ account().subtype | titlecase }}</dd>
        </div>
      }
      @if (account().officialName.trim()) {
        <div class="flex items-baseline justify-between gap-4 px-4 py-3">
          <dt class="shrink-0 text-text-muted">Official name</dt>
          <dd class="m-0 min-w-0 text-right font-semibold text-text-title">{{ account().officialName }}</dd>
        </div>
      }
    </dl>
  </app-drawer-section>

  @if (account() && credential()) {
    <form
      class="flex flex-1 flex-col"
      data-testid="account-details-form"
      #updateAccountDetailsForm="ngForm"
      (ngSubmit)="addAccountDetailsSave()"
      autocomplete="off"
    >
      <div class="grid auto-rows-min gap-6">
        <app-ui-field class="w-full" [label]="'Account nickname'" [inputId]="'account-details-nickname'">
          <input
            appUiInput
            id="account-details-nickname"
            data-testid="account-details-nickname"
            name="nickname"
            type="text"
            [ngModel]="nickname()"
            (ngModelChange)="nickname.set($event)"
          />
        </app-ui-field>

        <app-ui-field
          class="w-full"
          [label]="'Start date for transaction syncing'"
          [inputId]="'account-details-sync-start-date'"
          [error]="
            updateAccountDetailsForm.controls.syncStartDate?.errors?.['minDate']
              ? 'Cannot sync before ' + (minimumDateLabel$ | async)
              : null
          "
          [errorId]="syncStartDateErrorId"
        >
          <input
            #syncStartDateControl="ngModel"
            appUiInput
            id="account-details-sync-start-date"
            name="syncStartDate"
            [minDate]="(minimumDateValue$ | async) ?? ''"
            [min]="minimumDateValue$ | async"
            [disabled]="syncDisabled()"
            [attr.aria-describedby]="syncStartDateControl.errors?.['minDate'] ? syncStartDateErrorId : null"
            [attr.aria-invalid]="
              syncStartDateControl.invalid && (syncStartDateControl.dirty || syncStartDateControl.touched)
            "
            [ngModel]="syncStartDate()"
            (ngModelChange)="syncStartDate.set($event)"
            type="date"
          />
        </app-ui-field>

        <div class="account-details-toggle flex items-start">
          <div>
            <app-ui-checkbox
              inputId="account-details-include-in-available-balance"
              labelId="account-details-include-in-available-balance-label"
              ariaDescribedBy="account-details-include-in-available-balance-description"
              name="includeInAvailableBalance"
              [ngModel]="includeInAvailableBalance()"
              (ngModelChange)="includeInAvailableBalance.set($event)"
            >
              Include this account in Available Balance
            </app-ui-checkbox>
            <p
              id="account-details-include-in-available-balance-description"
              class="mt-1 pl-9 text-body-sm text-text-muted"
            >
              Use this account's balance and transactions to calculate how much you can assign to budgets.
              @if (account().type === 'investment' || account().type === 'brokerage') {
                Investment values can change without a transaction, so Available Balance may need periodic adjustment.
              }
            </p>
          </div>
        </div>

        <div class="account-details-toggle flex items-start">
          <app-ui-checkbox
            inputId="account-details-sync-disabled"
            labelId="account-details-sync-disabled-label"
            name="syncDisabled"
            [ngModel]="syncDisabled()"
            (ngModelChange)="syncDisabled.set($event)"
          >
            Disable syncing for this account
          </app-ui-checkbox>
        </div>
      </div>

      <app-drawer-footer class="account-details-actions">
        <span class="flex-1"></span>
        <button
          appUiButton
          appearance="solid"
          tone="primary"
          data-testid="account-details-save"
          [disabled]="!updateAccountDetailsForm?.valid || saving()"
          type="submit"
        >
          Save
        </button>
      </app-drawer-footer>
    </form>
  }
</div>
